import { useEffect } from 'react';
import { useState } from 'react';
import { transformExtent } from 'ol/proj.js';
import { GeoJSON } from 'ol/format.js';
import { ReactComponent as LeftArrow } from './images/left-arrow-pagination.svg';
import { ReactComponent as RightArrow } from './images/right-arrow-pagination.svg';
import { ReactComponent as CloseMessage } from './images/close-message.svg';
import { ReactComponent as Minimize } from './images/minimize.svg';
import { ReactComponent as SearchButton } from './images/magnify.svg';
import { ReactComponent as CollapseArrowIcon } from '../map/images/collapse-arrow.svg';
import { useDebounce } from 'use-debounce';

const FeaturesTable = ({ layerInfo, header }) => {
  const noOfElements = 5;
  const [showTable, setShowTable] = useState(true);
  const [columns, setColumns] = useState();
  const [features, setFeatures] = useState();
  const [minimizeTable, setMinimizeTable] = useState(false);
  const [activeRow, setActiveRow] = useState({ number: null, page: null });
  const [currentPage, setCurrentPage] = useState(1);
  const [currentList, setCurrentList] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [search, setSearch] = useState('');
  const [searchQuery, setSearchQuery] = useState();
  const [debouncedValue] = useDebounce(searchQuery, 500);

  const handleSearchQuery = (e) => {
    setSearchQuery(layerInfo.wfsUrl + "opis ILIKE '%25" + e + "%25'");
  };

  const handleSearch = (e) => {
    setSearch(e);
    handleSearchQuery(e);
  };

  const handleIconClick = () => {
    setIsExpanded((prev) => !prev);
  };

  useEffect(() => {
    const params = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    };
    fetch(search === '' ? layerInfo.wfsUrl : searchQuery, params)
      .then((data) => {
        return data.json();
      })
      .then((res) => {
        if (res.features.length > 0) {
          var columns = [];
          for (var key in res.features[0].properties) {
            columns.push(key);
          }
          setColumns(columns);
        }
        const features = new GeoJSON().readFeatures(res);

        setFeatures(features);

        if (features) {
          setCurrentPage(1);
          setActiveRow();
          setCurrentList(features.slice(0, noOfElements * 1));
        }
      });
  }, [header, debouncedValue]);

  useEffect(() => {
    setShowTable(true);
    if (features) {
      if (currentPage === 1)
        setCurrentList(features.slice(0, noOfElements * currentPage));
      else
        setCurrentList(
          features.slice(
            noOfElements * (currentPage - 1),
            noOfElements * currentPage
          )
        );
    }
  }, [currentPage]);

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  const handleNextPage = () => {
    if (noOfElements < features.length / currentPage)
      setCurrentPage((prev) => prev + 1);
  };

  return (
    <>
      {features && showTable && (
        <>
          <div className="header-config">
            <div className="pagination">
              {header}

              <LeftArrow
                className="pagination-arrow"
                style={{
                  opacity: currentPage > 1 ? '100%' : '10%',
                  cursor: currentPage > 1 ? 'pointer' : 'default',
                }}
                onClick={() => handlePreviousPage()}
              />
              <div className="table-current-page">
                {currentPage * noOfElements} / {features.length}
              </div>
              <RightArrow
                style={{
                  opacity:
                    noOfElements < features.length / currentPage
                      ? '100%'
                      : '10%',
                  cursor:
                    noOfElements < features.length / currentPage
                      ? 'pointer'
                      : 'default',
                }}
                className="pagination-arrow"
                onClick={() => handleNextPage()}
              />
            </div>

            <div className="header-right-side">
              {header === 'Vodomjerno mjesto - disabled' && (
                <div className="search-container">
                  {!isExpanded && (
                    <div
                      className="header-button search-button"
                      onClick={handleIconClick}
                    >
                      <SearchButton style={{ width: '10px' }} />
                    </div>
                  )}
                  {isExpanded && (
                    <div className="search-input-container">
                      <div className="header-button" onClick={handleIconClick}>
                        <CollapseArrowIcon style={{ height: '10px' }} />
                      </div>
                      <div className="search-with-clear">
                        <input
                          type="search"
                          className="search-input"
                          placeholder="Pretraži..."
                          value={search}
                          onChange={(e) => handleSearch(e.target.value)}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
              <div
                className="header-button"
                onClick={() => setMinimizeTable((prev) => !prev)}
              >
                <Minimize style={{ width: '10px' }} />
              </div>
              <div
                className="header-button"
                onClick={() => {
                  setShowTable(false);
                }}
              >
                <CloseMessage style={{ height: '10px' }} />
              </div>
            </div>
          </div>
          {!minimizeTable && (
            <div className="feature-table">
              <table className="feature-info">
                <thead className="feature-header">
                  <tr>
                    {columns.map((column) => (
                      <th style={{ paddingInline: '10px' }} key={column}>
                        {column}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="feature-body">
                  {currentList.map((feature, ind) => {
                    const properties = Object.values(feature.values_);
                    return (
                      <tr
                        key={ind}
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          const sourceProjection = 'EPSG:3908';
                          const destProjection = 'EPSG:3857';
                          const originalExtent = feature
                            .getGeometry()
                            .getExtent();

                          var extent = transformExtent(
                            [
                              originalExtent[0],
                              originalExtent[1],
                              originalExtent[2],
                              originalExtent[3],
                            ],
                            sourceProjection,
                            destProjection
                          );
console.log(window.map
  .getView().values_);
  window.map
  .getView().values_.zoom = 15
                          window.map
                            .getView()
                            .fit(extent, window.map.getSize(), {
                              constrainResolution: false,
                              duration: 500,
                            });
                        }}
                      >
                        {properties.map((property, index) => {
                          if (index !== 0)
                            return (
                              <td
                                key={`${property}${index}`}
                                className={`feature-attributes ${
                                  activeRow &&
                                  activeRow.number === ind &&
                                  activeRow.page === currentPage
                                    ? 'active-row'
                                    : ''
                                }`}
                                onClick={() =>
                                  setActiveRow({
                                    number: ind,
                                    page: currentPage,
                                  })
                                }
                              >
                                {property}
                              </td>
                            );
                          return <></>;
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default FeaturesTable;
